export class CourseType {
    courseTypeName: string;
    status: boolean;
    id: number;
}